<template>
  <div
    style="flex:1"
    ref="mscontent"
  >
    <message-service
      :request="request"
      :serveUrl="msgUrl"
      :token="token"
      :contentHeight="contentHeight"
    ></message-service>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import configR from '@/configs.js';
export default {
  computed: {
    ...mapGetters(["token", "request"]),
    msgUrl() {
      return configR.envConfigs.MESSAGE_API_URL;
    },
  },
  data() {
    return {
      contentHeight: 600,
    };
  },
  created() {
    this.contentHeight = document.getElementById(
      "business-center-container"
    ).offsetHeight;
  },
  methods: {},
};
</script>
